import { samanService } from '../_services';
import {spotservellienceConstants} from '../_constants';


export const samanAction = {
    saveSamanInformation,
    getSamansInformation,
    updatePSSideForm
}



function saveSamanInformation(data) {
    return dispatch => {
        dispatch(request());
        samanService.createSamanInformation(data)
            .then((response) => {
                dispatch(success(response));
            }, error => {
                dispatch(failure(error));
            })
    }
   
    function request(qrInfo) {
        return {
            type: spotservellienceConstants.SAVE_QRINFO_REQUEST,
            qrInfo
        }
    }
    function success(qrInfo) {
        return {
            type: spotservellienceConstants.SAVE_QRINFO_SUCCESS,
            qrInfo
        }
    }
    function failure(error) {
        return {
            type: spotservellienceConstants.SAVE_QRINFO_FAILURE,
            error
        }
    }
}

function getSamansInformation() {
    return samanService.getSamansInformation();
}

function updatePSSideForm(data,id) {
    console.log(data, id)
    return dispatch => {
        dispatch(request());
        samanService.updatePSSide(data,id)
            .then((response) => {
                dispatch(success(response));
            }, error => {
                dispatch(failure(error));
            })
    }
   
    function request(qrInfo) {
        return {
            type: spotservellienceConstants.SAVE_QRINFO_REQUEST,
            qrInfo
        }
    }
    function success(qrInfo) {
        return {
            type: spotservellienceConstants.SAVE_QRINFO_SUCCESS,
            qrInfo
        }
    }
    function failure(error) {
        return {
            type: spotservellienceConstants.SAVE_QRINFO_FAILURE,
            error
        }
    }
}

